export default {
	'add-vehicle': 'إضافة عربة',
	'edit-vehicle': 'تعديل عربة',
	'reconnect-gps': 'إعادة الاتصال بأجهزة GPS',
	'confirm-reconnecting-gps': 'تأكيد إعادة الاتصال',
	'confirm-reconnecting-message': 'هل أنت متأكد من إعادة الاتصال بأجهزة GPS؟',
}